import { Action } from 'vuex'
import { RootState } from '@/store/types'
import { MediaLibraryState } from '../types'
import { MediaLibraryImage } from '@/types/mediaLibrary'
import SiriusAPI from '@/api'

const deleteImageMediaLibrary: Action<MediaLibraryState, RootState> = async (
  { commit },
  payload: MediaLibraryImage & { index_delete: number }
) => {
  try {
    SiriusAPI.mediaLibrary.deleteImageMediaLibrary({
      essence: payload.essence,
      essenceId: payload.essenceId,
      image_id: payload.image_id,
    })

    commit('deleteImageMediaLibrary', {
      essence: payload.essence,
      index_delete: payload.index_delete,
    })
  } catch (error) {
    console.error(error)
  }
}

export default deleteImageMediaLibrary
